import { render, staticRenderFns } from "./PackNfcIcon.vue?vue&type=template&id=242ec66c"
import script from "./PackNfcIcon.vue?vue&type=script&lang=js"
export * from "./PackNfcIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports